import { render } from "./about_page.vue?vue&type=template&id=4169fdef&scoped=true"
import script from "./about_page.vue?vue&type=script&lang=js"
export * from "./about_page.vue?vue&type=script&lang=js"

import "./about_page.vue?vue&type=style&index=0&id=4169fdef&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4169fdef"]])

export default __exports__